import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import ZoneGuard from "../../components/route-guard/ZoneGuard";
import Home from "../Home";
import MainLayout from "../../components/layout/MainLayout";
import InterestOptions from "../../components/interest/InterestOptions";
import useConfigData from "../../hooks/useConfigData";
import SplashScreen from "../../splash-screen";

const Index = ({ configData }) => {
  return (
    <>
      <CssBaseline />
      <MainLayout configData={configData}>
        <InterestOptions configData={configData} />
      </MainLayout>
    </>
  );
};

export default Index;
Index.getLayout = (page) => <ZoneGuard>{page}</ZoneGuard>;
